import { Box, styled } from "@mui/material";

const ToggleButtonContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isCollapse" && prop !== "isClicked",
})<{ isCollapse: boolean; isClicked: boolean }>(
  ({ isCollapse, isClicked }) => ({
    "@keyframes fadeInOut": {
      "0%": {
        opacity: 0,
      },
      "60%": {
        opacity: 0,
      },
      "100%": {
        opacity: 1,
      },
    },
    fontSize: "11px",
    position: "absolute",
    color: "#7f9ac4",
    cursor: "pointer",
    zIndex: "100",

    ...(!isCollapse && {
      top: "100px",
      right: "16px",
    }),

    ...(isCollapse && {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "78px",
      top: "8px",
      gap: "8px",
    }),

    ...(isClicked && {
      animation: "fadeInOut 0.3s forwards",
    }),
  }),
);

const ArrowContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isCollapse",
})<{ isCollapse: boolean }>(({ isCollapse }) => ({
  display: "flex",
  alignItems: "center",
  ...(isCollapse && {
    paddingRight: "10px",
  }),
}));

export { ToggleButtonContainer, ArrowContainer };
